<div [ngClass]="variant" class="listing-details-promoted-content" [class.small]="smallListing">
	<div class="image-container">
		<div class="content-image-preview" *ngIf="!listing?.imgUrls?.length">
			<i class="fas fa-image"></i>
		</div>

		<ng-container *ngIf="listing?.imgUrls?.length">
			<a [href]="getUrl()" target="_blank" (click)="onClick()" *ngIf="getUrl()">
				<img [src]="listing.imgUrls[0]" width="100%" loading="lazy" [alt]="listing.address" />
			</a>

			<img [src]="listing.imgUrls[0]" width="100%" loading="lazy" *ngIf="!getUrl()" [alt]="listing.address" />
		</ng-container>

		<div class="listing-details" *ngIf="isPanoramic">
			<h3 class="listing-details__price" *ngIf="listing?.price">
				<span translate>currency</span> {{ listing.price | number }}
			</h3>
			<h4 class="listing-details__address" *ngIf="listing?.address">{{ listing.address }}</h4>
		</div>

		<div class="listing-tags" *ngIf="!isHorizontal">
			<span class="for-sale" *ngIf="!listing?.lease">{{ 'listing.forSale' | translate }}</span>
			<span class="for-rent" *ngIf="listing?.lease">{{ 'listing.forRent' | translate }}</span>
		</div>
	</div>

	<div class="wrapper-content">
		<div class="listing-details" *ngIf="!isPanoramic">
			<div class="listing-details-horizontal">
				<h3 class="listing-details__price" *ngIf="listing?.price">
					<span translate>currency</span> {{ listing.price | number }}
				</h3>

				<div class="listing-tags" *ngIf="isHorizontal">
					<span class="for-sale" *ngIf="!listing?.lease">{{ 'listing.forSale' | translate }}</span>
					<span class="for-rent" *ngIf="listing?.lease">{{ 'listing.forRent' | translate }}</span>
				</div>
			</div>

			<h4 class="listing-details__address" *ngIf="listing?.address">{{ listing.address }}</h4>
		</div>
		<ul
			class="listing-meta"
			[ngClass]="{ three: countMetaItems === 3, two: countMetaItems === 2 }"
			*ngIf="countMetaItems !== 0"
		>
			<li *ngIf="listing?.sqft > 0">
				<div class="listing-meta__item">
					<i class="fa-regular fa-vector-square"></i>
					<span>{{ listing.sqft | number }} {{ 'promotedContent.listingMeta.sqft' | translate }}</span>
				</div>
			</li>
			<li *ngIf="listing?.bedrooms > 0">
				<div class="listing-meta__item">
					<i class="fa-regular fa-bed"></i>
					<span>{{ listing.bedrooms | number }} {{ 'promotedContent.listingMeta.beds' | translate }}</span>
				</div>
			</li>
			<li *ngIf="listing?.bathrooms && listing?.bathrooms !== '0'">
				<div class="listing-meta__item">
					<i class="fa-regular fa-bath"></i>
					<span>{{ listing.bathrooms }} {{ 'promotedContent.listingMeta.baths' | translate }}</span>
				</div>
			</li>
		</ul>
	</div>
</div>
